import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const authToken = this.auth.getAccessToken();
    const newHeaders = req.headers.delete('cache');

    const authReq = req.clone({
      headers: newHeaders.set('Authorization', `Bearer ${authToken}`),
    });

    return authToken ? next.handle(authReq) : next.handle(req);
  }
}
